import { InlineContentTypes } from '../templates/Publication/SharedPublication.routing'
import { metrics } from '../__styling'

export interface InlineArticleAdsProps {
    insertAfter: number
    noticePosition: 'above-center' | 'below-center' | 'none'
    hiddenUntilLoaded: boolean
    mastHead: 'sevennews' | 'thewest' | 'perthnow' | 'thenightly'
    slotID: string
    size: 'alwaysMrecMultiSize' | 'alwaysMrec' | 'below768Mrec'
    pageType: 'article' | 'liveblog' | 'gallery'
}

type PaddingOptions = Record<
    InlineArticleAdsProps['mastHead'],
    [number, number, number, number]
>

const paddingOptions: PaddingOptions = {
    thewest: [0, 0, metrics.thewest.margins.md, 0],
    sevennews: [
        metrics.sevennews.margins.xs,
        0,
        metrics.sevennews.margins.lg,
        0,
    ],
    perthnow: [18, 0, 18, 0],
    thenightly: [0, 0, metrics.thenightly.textMargin, 0],
}

export function inlineArticleAds({
    insertAfter,
    noticePosition,
    hiddenUntilLoaded,
    mastHead,
    slotID,
    size,
    pageType,
}: InlineArticleAdsProps): InlineContentTypes {
    return {
        kind: 'ad',
        insertAfter: insertAfter,
        content: [
            {
                noticePosition,
                hiddenUntilLoaded,
                padding: paddingOptions[mastHead],
                slot: {
                    id: slotID,
                    size,
                    pageType,
                },
                adType: 'inline',
            },
        ],
    }
}
